(function ($) {
    $(document).on('click', '.Upsell__Close', function(){
      $(this).closest('.Upsell').fadeOut('fast');
    });

    window.setCookie = function(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };
  
    window.addUpsellToCart = function(target) {
      if (target.getAttribute('disabled') === 'disabled') {
        return;
      }
    
      const variantId = target.getAttribute('data-variant-id');
      let quantity = 1;

      // Find the quantity input more specifically
      const container = $(target).closest('.upsell-product, .Upsell__Item');
      const quantityInput = container.find('.QuantitySelector__CurrentQuantity');
      
      if (quantityInput.length) {
        const maxVal = parseInt(quantityInput.attr('max')) || 9999;
        quantity = parseInt(quantityInput.val()) || 1;
        
        // Make sure quantity doesn't exceed maximum
        if (quantity > maxVal) {
          quantity = maxVal;
          quantityInput.val(maxVal);
        }
      }
  
      target.style.opacity = '0.5';
      target.setAttribute('disabled', 'disabled');
  
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          id: variantId,
          quantity: quantity
        },
        dataType: 'json',
        success: function(data) { 
          window.setCookie('show_cart', 'true', 1);
          window.location.reload(true);
        },
        error: function(xhr, status, error) {
          console.error('Error adding product to cart:', error);
          target.style.opacity = '1';
          target.removeAttribute('disabled');
          alert('Failed to add product to cart. Please try again.');
        }
      });
    };

    // Add handlers for quantity buttons
    $(document).on('click', '.QuantitySelector__Button', function(e) {
      e.preventDefault();
      const input = $(this).siblings('.QuantitySelector__CurrentQuantity');
      const currentVal = parseInt(input.val()) || 1;
      const maxVal = parseInt(input.attr('max')) || 9999;
      
      if ($(this).hasClass('QuantitySelector__Plus')) {
        if (currentVal < maxVal) {
          input.val(currentVal + 1);
        }
      } else if ($(this).hasClass('QuantitySelector__Minus')) {
        if (currentVal > 1) {
          input.val(currentVal - 1);
        }
      }
    });

    // Add handler for direct input
    $(document).on('change', '.upsell-quantity-input, .QuantitySelector__CurrentQuantity', function() {
      const min = parseInt($(this).attr('min')) || 1;
      const max = parseInt($(this).attr('max')) || 100;
      let val = parseInt($(this).val()) || min;

      if (val < min) {
        val = min;
      } else if (val > max) {
        val = max;
      }

      $(this).val(val);
    });

})(jQuery);
